<template>
<div class="md-example-child md-example-child-skeleton md-example-child-skeleton-2 hot-skeleton">
  <md-field>
    <md-skeleton avatar class="skeleton-item1" :row="1">
    </md-skeleton>
    <div class="skeleton-content">
       <div class="content-tabs">
          <md-skeleton class="skeleton-tabs" :row="1">
          </md-skeleton>
          <md-skeleton class="skeleton-menu" :row="1">
          </md-skeleton>
        </div>
        <md-skeleton class="skeleton-mqrquee" :row="1">
        </md-skeleton>
        <md-skeleton class="skeleton-banner" :row="1">
        </md-skeleton>
        <div class="footer-tabs">
            <md-skeleton class="skeleton-items" :row="1">
            </md-skeleton>
            <md-skeleton class="skeleton-items" :row="1">
            </md-skeleton>
            <md-skeleton class="skeleton-items" :row="1">
            </md-skeleton>
        </div>
        <div class="footer-content">
            <md-skeleton avatar v-for="index in 4" :key="index" class="skeleton-items" :row="1">
            </md-skeleton>
        </div>
    </div>
  </md-field>
</div>
</template>
<script>
import { Skeleton, Field, CellItem } from 'mand-mobile';
export default {
  name: 'AppSkeleton',
  components: {
    [Skeleton.name]: Skeleton,
    [Field.name]: Field,
    [CellItem.name]: CellItem
  }
};
</script>
<style lang="scss">
.hot-skeleton {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: #fff;
    .md-field {
        padding: 10px;
        .skeleton-item1 {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            .md-skeleton-avatar {
                width: 50px;
                height: 50px;
                margin-right: 10px;
            }
            .md-skeleton-content {
                .md-skeleton-row {
                    width: 100% !important;
                }
            }
        }
        .skeleton-content {
            .content-tabs {
                display: flex;
                gap: 10px;
                justify-content: space-between;
                .skeleton-tabs {
                    width: 90%;
                    height: 30px;
                    .md-skeleton-row {
                        width: 100% !important;
                    }
                }
                .skeleton-menu {
                    flex: 1;
                    height: 30px;
                    .md-skeleton-row {
                        width: 100% !important;
                    }
                }
            }
        }
        .skeleton-mqrquee {
            margin-top: 10px;
            .md-skeleton-row {
                width: 100% !important;
            }
        }
        .skeleton-banner {
            margin-top: 10px;
            .md-skeleton-row {
                // background: url('~@/assets/imgs/public/logo.png') no-repeat center center;
                // background-size: cover;
                height: 173px;
                border-radius: 8px;
                width: 100% !important;
            }
        }
        .footer-tabs {
            display: flex;
            margin-top: 10px;
            gap: 10px;
            .skeleton-items {
                width: 30px;
                .md-skeleton-row {
                    width: 100% !important;
                }
            }
        }
        .footer-content {
            display: flex;
            margin-top: 10px;
            gap: 10px;
            flex-wrap: wrap;
            .skeleton-items {
                width: 172px;
                display: flex;
                flex-direction: column;
                .md-skeleton-avatar {
                    width: 172px;
                    height: 102px;
                    border-radius: 8px;
                }
                .md-skeleton-content {
                    margin-top: 10px;
                    .md-skeleton-row {
                        width: 100% !important;
                    }
                }
            }
        }
    }
}
</style>
